import { __awaiter } from "tslib";
import { ImageTransformHelper } from '@getaccept/editor-lib-new';
import { nextTick, defineComponent, computed, ref, watch } from 'vue';
export default defineComponent({
    name: 'ImageWithTransforms',
    props: {
        image: { type: Object, default: () => ({}) },
        blockWidthClass: {
            type: String,
            default: null,
        },
        pageWidth: { type: Number, default: 0 },
        isBlockToggled: { type: Boolean },
    },
    emits: ['image-load-error', 'image-loaded'],
    setup(props, { emit }) {
        const imageLoadElement = ref(null);
        const insideRef = ref(null);
        const containerRef = ref(null);
        const scale = computed(() => { var _a; return ((_a = props.image.imageTransforms) === null || _a === void 0 ? void 0 : _a.scale) || ImageTransformHelper.SCALE_MIN_VALUE; });
        const ratio = computed(() => scale.value / 100);
        const translateX = computed(() => { var _a; return ((_a = props.image.imageTransforms) === null || _a === void 0 ? void 0 : _a.translateX) || 0; });
        const translateY = computed(() => { var _a; return ((_a = props.image.imageTransforms) === null || _a === void 0 ? void 0 : _a.translateY) || 0; });
        const resetImage = () => __awaiter(this, void 0, void 0, function* () {
            yield nextTick();
            if (!insideRef.value) {
                return;
            }
            insideRef.value.style.backgroundImage = 'url()';
        });
        const setImageSize = () => __awaiter(this, void 0, void 0, function* () {
            yield nextTick();
            if (!containerRef.value) {
                return;
            }
            const { clientWidth: areaWidth, clientHeight: areaHeight } = containerRef.value;
            const { naturalWidth, naturalHeight } = imageLoadElement.value;
            if (!naturalWidth || !areaWidth) {
                return;
            }
            const [initialWidth, initialHeight] = ImageTransformHelper.getInitialImageSize(naturalWidth, naturalHeight, areaWidth, areaHeight);
            const transformOrigin = ImageTransformHelper.getTransformOrigin(initialHeight * ratio.value, initialWidth * ratio.value, areaHeight, areaWidth);
            insideRef.value.style.transformOrigin = transformOrigin;
            insideRef.value.style.width = `${initialWidth}px`;
            insideRef.value.style.height = `${initialHeight}px`;
        });
        const handleImageLoaded = () => __awaiter(this, void 0, void 0, function* () {
            yield nextTick();
            if (!insideRef.value) {
                return;
            }
            insideRef.value.style.backgroundImage = `url(${imageLoadElement.value.src})`;
            setImageSize();
            emit('image-loaded');
        });
        const handleImageError = () => {
            emit('image-load-error');
        };
        watch(() => props.image.imageTransforms, () => __awaiter(this, void 0, void 0, function* () {
            yield nextTick();
            if (!insideRef.value) {
                return;
            }
            const translateXCSS = `translateX(${translateX.value / ratio.value}%)`;
            const translateYCSS = `translateY(${translateY.value / ratio.value}%)`;
            insideRef.value.style.transform = `scale(${ratio.value}) ${translateXCSS} ${translateYCSS} translateZ(0)`;
        }), { immediate: true });
        watch(() => props.isBlockToggled, () => {
            if (!props.isBlockToggled) {
                return;
            }
            setImageSize();
        });
        watch(() => props.pageWidth, () => {
            setImageSize();
        });
        watch(() => props.image.srcUrl, () => {
            imageLoadElement.value = new Image();
            imageLoadElement.value.onload = handleImageLoaded;
            imageLoadElement.value.onerror = handleImageError;
            imageLoadElement.value.src = props.image.srcUrl;
            if (!props.image.srcUrl) {
                resetImage();
            }
        }, { immediate: true });
        return {
            insideRef,
            containerRef,
            resetImage,
            handleImageLoaded,
            handleImageError,
            imageLoadElement,
        };
    },
});
